import { requestJson } from "services/http";

export async function apiFetch(path, { method = "GET", body, isFormData = false } = {}) {
  const options = { method };

  if (body) {
    if (isFormData) {
      options.body = body;
    } else {
      options.headers = { "Content-Type": "application/json" };
      options.body = JSON.stringify(body);
    }
  }
  return requestJson(path, options);
}

// Devices
export const getDevices = () => apiFetch("/api/padihat/devices/");
export const getDeviceData = (mac, params = "") =>
  apiFetch(`/api/padihat/devices/${mac}/data${params ? `?${params}` : ""}`);
export const updateDevice = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/update/`, { method: "PUT", body });
export const updateCalibration = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/calibration/`, { method: "PUT", body });
export const sendMqttConfig = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/config/send/`, { method: "POST", body });
export const getDiagnostics = (mac) =>
  apiFetch(`/api/padihat/devices/${mac}/diagnostics/`);
export const getLogs = (mac, limit) =>
  apiFetch(`/api/padihat/devices/${mac}/logs/?limit=${limit}`);
export const getTelemetry = (mac, limit = 20) =>
  apiFetch(`/api/padihat/devices/${mac}/telemetry/?limit=${limit}`);
export const getTelemetrySeries = (mac, fields, start, end, limit = 1000) => {
  const params = new URLSearchParams({ fields: fields.join(","), limit });
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  return apiFetch(`/api/padihat/devices/${mac}/telemetry-series/?${params.toString()}`);
};
export const getRawSamples = (mac, start, end, limit = 1000, full = false) => {
  const params = new URLSearchParams({ limit });
  if (start) params.set("start", start);
  if (end) params.set("end", end);
  if (full) params.set("full", "1");
  return apiFetch(`/api/padihat/devices/${mac}/raw-samples/?${params.toString()}`);
};
export const getDeviceStatus = (mac) =>
  apiFetch(`/api/padihat/devices/${mac}/status/`);
export const getProcessedWaterLevel = (mac, start, end) => {
  const params = new URLSearchParams();
  if (start) params.set('start_time', new Date(start).toISOString());
  if (end)   params.set('end_time',   new Date(end).toISOString());
  const qs = params.toString();
  return apiFetch(`/api/padihat/devices/${mac}/processed-water-level/${qs ? `?${qs}` : ''}`);
};
export const getSystemOverview = (includeArchived = false) =>
  apiFetch(`/api/padihat/overview/${includeArchived ? "?include_archived=true" : ""}`);

// Firmware
export const getFirmwareVersions = () => apiFetch("/api/firmware/versions/");
export const getFirmwareStats = () => apiFetch("/api/firmware/statistics/");
export const getFirmwareDeployments = (params = "") =>
  apiFetch(`/api/firmware/deployments/?${params}`);
export const uploadFirmware = (formData) =>
  apiFetch("/api/firmware/upload/", { method: "POST", body: formData, isFormData: true });
export const deployFirmware = (mac, body) =>
  apiFetch(`/api/firmware/deploy/${mac}/`, { method: "POST", body });
export const deployGreenhouseFirmware = (mac, body) =>
  apiFetch(`/api/firmware/deploy-greenhouse/${mac}/`, { method: "POST", body });
export const updateFirmwareVersion = (firmwareId, body) =>
  apiFetch(`/api/firmware/versions/${firmwareId}/update/`, { method: "PATCH", body });

// AWD — Alternate Wetting and Drying
export const getAWDEvents = (mac, params = "") =>
  apiFetch(`/api/padihat/devices/${mac}/awd-events/${params ? `?${params}` : ""}`);
export const createAWDEvent = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/awd-events/`, { method: "POST", body });
export const getAWDCycles = (mac, params = "") =>
  apiFetch(`/api/padihat/devices/${mac}/awd-cycles/${params ? `?${params}` : ""}`);
export const getAWDCycleDetail = (mac, id) =>
  apiFetch(`/api/padihat/devices/${mac}/awd-cycles/${id}/`);
export const getAWDStatus = (mac) =>
  apiFetch(`/api/padihat/devices/${mac}/awd-status/`);
export const getAWDConfig = (mac) =>
  apiFetch(`/api/padihat/devices/${mac}/awd-config/`);
export const updateAWDConfig = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/awd-config/`, { method: "PUT", body });
export const getCropCycle = (mac) =>
  apiFetch(`/api/padihat/devices/${mac}/crop-cycle/`);
export const saveCropCycle = (mac, body) =>
  apiFetch(`/api/padihat/devices/${mac}/crop-cycle/`, { method: "POST", body });
